import { Snackbar, TextField } from "@material-ui/core";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import update from "immutability-helper";
import Select from "react-select";
import makeAnimated from "react-select/animated";

import { getAllTransporters } from "../../reduxSaga/actions";
import { useEffect, useState, useRef } from "react";
import { Alert } from "@material-ui/lab";
import React from "react";
// import PictureAsPdfOutlinedIcon from "@material-ui/icons/PictureAsPdfOutlined";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Check from "@material-ui/icons/Check";
import SettingsIcon from "@material-ui/icons/Settings";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import TransferService from "../../services/TransferBetweenWarehouses";
import WarehouseService from "../../services/WarehouseService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import SellingService from "../../services/SellingService";
import PurchaseService from "../../services/PurchaseOrder";
import withLoader from "../../components/layouts/WithLoader";

const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: "#000000",
  },
  circle: {
    width: 8,
    height: 8,
    color: "#fff",
    borderRadius: "50%",
    backgroundColor: "#000000",
  },
  completed: {
    color: "#000000",
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,
};

const useColorlibStepIconStyles = makeStyles({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#000",
      width: 50,
      height: 50,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  active: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      color: "#000000",
    },
  },
  completed: {
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SettingsIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,

  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      width: "100%",
      color: "#000000",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  icon: {
    color: "#000",
  },
}));

function getSteps() {
  return ["Informations", "Choisir les produits", "Finaliser"];
}

const WarehouseTransfertAdmin = ({startLoading,stopLoading}) => {
  const dispatch = useDispatch();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [infoAlertText, setInfoAlertText] = useState();
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  const [currentQteProductPurchase, setCurrentQteProductPurchase] =
    React.useState("nothing");
  const [warehouseSourceId, setWarehouseSourceId] = useState(0);
  const [idUser, setIdUser] = useState(0);
  const [warehouseDestinationId, setWarehouseDestinationId] = useState(0);
  const [transportorId, setTransportorId] = useState(0);
  const [date, setDate] = React.useState("");
  const [transfertNote, setTransfertNote] = React.useState("");
  const [product, setProduct] = React.useState(0);
  const [qteWarehouseSource, setQteWarehouseSource] = React.useState("nothing");
  const [amount, setAmount] = React.useState(0);
  const [productTableData, setProductTableData] = React.useState([]);
  const [productMapById, setProductMapById] = React.useState([]);
  // const [reference, setReference] = React.useState("");

  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionTwo, setSelectedOptionTwo] = useState(null);
  const [selectedOptionThree, setSelectedOptionThree] = useState(null);
  const [selectedOptionProduct, setSelectedOptionProduct] = useState(null);
  const [products, setProducts] = React.useState([{}]);
  const [allProducts, setAllProducts] = React.useState([{}]);

  const animatedComponents = makeAnimated();
  const animatedComponentsProduct = makeAnimated();

  const [allWarehouseSource, setAllWarehouseSource] = React.useState([{}]);
  const [allWarehouseDestination, setAllWarehouseDestination] = React.useState([
    {},
  ]);
  const [allTransportors, setAllTransportors] = React.useState([{}]);
  const [warehousesSource, setWarehousesSource] = useState([]);
  const [warehousesDestination, setwarehousesDestination] = useState([]);
  const [productSelectPlaceHolder, setProductSelectPlaceHolder] =
    useState("Choisir...");

  const [availableBDCSelectedOption, setAvailableBDCSelectedOption] =
    useState(null);
  const [allAvailableBDC, setAllAvailableBDC] = React.useState([{}]);
  const [availableBDCSelectPlaceHolder, setAvailableBDCSelectPlaceHolder] =
    useState("Choisir...");
  const [bdcReference, setBdcReference] = useState("");
  const [rateTableData, setRateTableData] = useState([]);

  const onChangeBDCReferenceHandler = (selectedOptionn) => {
    setBdcReference(selectedOptionn.value);
    setAvailableBDCSelectedOption();

    setAvailableBDCSelectPlaceHolder(selectedOptionn.label);
  };

  const onGetBDCByReference = () => {
    // here
    if (bdcReference === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucune réference");
    } else {
      PurchaseService.getBDCByRefForTransfert(bdcReference)
        .then((response) => {
          if (
            response.data.products != null &&
            response.data.products.length > 0
          ) {
            setProductMapById([]);
            setProductTableData([]);
            const barcodeByProductId = {};
            (response.data.success?.purchases || []).forEach((purchase) => {
              if (purchase.product?.id != null) {
                barcodeByProductId[purchase.product.id] =
                  purchase.product.barcode;
              }
            });
            response.data.products.forEach((element) => {
              let lot = 0;
              if (element.manufacturingBatch != null) {
                lot = element.manufacturingBatch.id;
              }
              const barcode =
                element.barcode ?? barcodeByProductId[element.id] ?? null;
              setProductMapById((previoustate) => [
                ...previoustate,
                {
                  id: element.id,
                  quantity: element.qte,
                  productName: element.productName,
                  barcode: barcode,
                },
              ]);
              setProductTableData((previoustate) => [
                ...previoustate,
                {
                  id: element.id,
                  qte: element.qte,
                  productName: element.productName,
                  barcode: barcode,

                },
              ]);
            });
            // response.data.success.ratePPs.forEach((element) => {
            //   setRateTableData((previoustate) => [
            //     ...previoustate,
            //     {
            //       idRate: element.idRate,
            //       name: element.name,
            //       value: element.value,
            //       code: element.code,
            //       type: element.type,
            //       typeTax: element.typeTax,
            //       typeTVA: element.typeTVA,
            //       refBill: element.refBill,
            //     },
            //   ]);
            // });
          } else if (Object.keys(response.data.products)[0] === "empty") {
            setOpenInfoAlert(true);
            setInfoAlertText(
              "info : aucun bon de commande  avec ce réference   "
            );
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });
    }
  };

  const transporteurs = useSelector(
    (state) => state.staff.transporters.success
  );

  const handlerChangeQt = (event) => {
    setAmount(event.target.value);
  };

  const onDeleteProduct = (id) => {
    setProductTableData(productTableData.filter((item) => item.id !== id));
    setProductMapById(productMapById.filter((item) => item.id !== id));
  };
  useEffect(() => {
    dispatch(getAllTransporters());
    // WarehouseService.getAllVirtualWarehouse(getCurrentUserId(), 0)
    //   .then((response) => {
    //     setwarehousesDestination(response.data.success);
    //   })
    //   .catch((error) => {
    //     console.log("error", error);
    //   });
    WarehouseService.getAllWarehouse(getCurrentUserId())
      .then((response) => {
        // console.log("response", response);
        if (response.data.success) {
          setWarehousesSource(response.data.success);
          setwarehousesDestination(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });
    PurchaseService.getAllBDCNotArchived()
      .then((response) => {
        if (Object.keys(response.data)[0] === "empty") {
          setAvailableBDCSelectPlaceHolder("Vide");
        } else if (Object.keys(response.data)[0] === "success") {
          let backendData = [{}];
          response.data.success.map((element) => {
            let elem = { value: element, label: element };
            backendData.push(elem);
          });
          setAllAvailableBDC(backendData);
          setAvailableBDCSelectPlaceHolder("Choisir...");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  }, []);

  useEffect(() => {
    warehousesSource &&
      warehousesSource.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
      });
  }, [warehousesSource]);

  useEffect(() => {
    warehousesDestination &&
      warehousesDestination.map((element) => {
        let exist = false;
        if (allWarehouseDestination.length !== 0) {
          for (let index = 0; index < allWarehouseDestination.length; index++) {
            if (allWarehouseDestination[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseDestination((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
      });
  }, [warehousesDestination]);

  useEffect(() => {
    transporteurs &&
      transporteurs.map((element) => {
        let exist = false;
        if (allTransportors.length !== 0) {
          for (let index = 0; index < allTransportors.length; index++) {
            if (allTransportors[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllTransportors((oldArray) => [
            ...oldArray,
            {
              value: element.id,
              label: element.firstName + " " + element.lastName,
            },
          ]);
        }
        //here
      });
  }, [transporteurs]);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangeDescriptionHandler = (event) => {
    noteEditedRef.current = event.target.value.trim() !== "";
    setTransfertNote(event.target.value);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  // Note par défaut : "Transfert de {source} vers {destination} au date de {date limite}"
  const noteEditedRef = useRef(false);
  useEffect(() => {
    if (noteEditedRef.current) return;
    const nameOf = (options, id) => {
      const found = options.find((o) => o.value === id);
      return found ? found.label : "";
    };
    const sourceName = nameOf(allWarehouseSource, warehouseSourceId);
    const destinationName = nameOf(allWarehouseDestination, warehouseDestinationId);
    if (!sourceName || !destinationName) return;
    let note = `Transfert de ${sourceName} vers ${destinationName}`;
    if (date) {
      const d = new Date(date);
      if (!isNaN(d.getTime())) {
        note += ` au date de ${d.toLocaleString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })}`;
      }
    }
    setTransfertNote(note);
  }, [
    warehouseSourceId,
    warehouseDestinationId,
    date,
    allWarehouseSource,
    allWarehouseDestination,
  ]);

  const handleOnChangeDate = (event) => {
    setDate(event.target.value);
  };

  const onAddProductToList = (event) => {
    let name = null;
    let barcode = null;
    let exist = false;
    let indexInDataTable;
    try {
      productMapById.forEach((element, index) => {
        if (element.id === product) {
          indexInDataTable = index;

          exist = true;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    try {
      console.log("allProducts", allProducts);

      allProducts.forEach((element) => {
        console.log("element", element);
        if (element.value === product) {
          name = element.label;
          barcode = element.barcode;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }
    if (amount > parseInt(qteWarehouseSource)) {
      setOpenErrorAlert(true);
      setErrorAlertText(
        "Erreur : la quantité de ce produit est indisponible dans le dépot "
      );
    } else if (amount === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : la quantité doit etre sup a zero");
    } else {
      if (!exist && amount !== 0) {
        setProductMapById((previoustate) => [
          ...previoustate,
          { id: product, quantity: amount },
        ]);
        setProductTableData((previoustate) => [
          ...previoustate,
          { id: product, qte: amount, productName: name, barcode: barcode },
        ]);
      } else if (exist && amount !== 0) {
        //  setProductMapById((previoustate) => [...previoustate,{ "id": product, "quantity": amount }]);

        let newState = update(productTableData, {
          [indexInDataTable]: {
            qte: { $set: amount },
          },
        });
        let newStateTwo = update(productMapById, {
          [indexInDataTable]: {
            qte: { $set: amount },
          },
        });
        setOpenInfoAlert(true);
        setInfoAlertText(
          "Info : tu as actualisé la quantité de produit :  " + name
        );
        setProductMapById(newStateTwo);
        setProductTableData(newState);
      }
    }
  };

  const handleNext = () => {
    if (activeStep === 0) {
      var deadLine = new Date(date);

      var today = new Date();

      if (warehouseSourceId === 0) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : le champ de dépot source est vide");
      } else if (warehouseDestinationId === 0) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : le champ de dépot destination est vide");
      } else if (transportorId === 0) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : le champ de transporteur est vide");
      } else if (warehouseSourceId === warehouseDestinationId) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : la destination et la source sont egaux");
      } else if (date === "") {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : la date limite est vide");
      } else if (deadLine < today) {
        setOpenErrorAlert(true);
        setErrorAlertText(
          "Erreur :la date limite une inferieur a la date d'aujourd'hui "
        );
      } else if (transfertNote === "") {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : la disignation est vide");
      } else {
        setAllProducts([]);

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    } else if (activeStep === 1) {
      if (productTableData.length === 0) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :aucun produit à transférer");
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    } else if (activeStep === 2) {
      let hash = new Object();

      console.log("productTableData", productTableData);
      productTableData.forEach((element) => {
        hash[(element.barcode ?? element.id).toString()] = element.qte;
      });

      let warehouseTransfertModel = {
        deadline: date,
        description: transfertNote,
        idTransportor: transportorId,
        idWarhouseDestination: parseInt(warehouseDestinationId),
        idWarhouseSource: parseInt(warehouseSourceId),
        productTransaction: hash,
        userCreation: getCurrentUserId(),
      };

      console.log(
        "warehouseTransfertModel",
        JSON.stringify(warehouseTransfertModel)
      );
    startLoading();
      TransferService.addWarehouseTransfertAdmin(warehouseTransfertModel)
        .then((response) => {
          if (response.data.success) {
            setOpenSuccessAlert(true);
            setSuccessAlertText("Enregistrement avec succées");
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
          } else if (Object.keys(response.data)[0] === "ref_error") {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : ce réference est déja existe  ");
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un erreur  ");
          }
        })
        .catch((error) => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : "+error);
        }).finally(()=>{
          stopLoading();
        })
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const onChangeSelectedWarehouseSource = (selectedOptionn) => {
    setSelectedOption();
    setWarehouseSourceId(selectedOptionn.value);
    // console.log("warehouseSourceID", selectedOptionn.value);
  };

  const onChangeSelectedWarehouseDestination = (selectedOptionn) => {
    setSelectedOptionTwo();
    setWarehouseDestinationId(selectedOptionn.value);
    // console.log(selectedOptionn.value);
  };
  const columns = [
    {
      dataField: "productName",
      text: "Libellé",
      headerAlign: "center",
    },

    {
      dataField: "qte",
      text: "Qte",
      align: "center",
      headerAlign: "center",
    },
  ];
  const onChangeSelectedTransportor = (selectedOptionn) => {
    setSelectedOptionThree();
    setTransportorId(selectedOptionn.value);
    // console.log(selectedOptionn.value);
  };
  // ── Recherche de produits (appel au service après 2 s sans saisie) ──────────
  const PRODUCT_SEARCH_DELAY_MS = 2000;
  const [isSearchingProducts, setIsSearchingProducts] = useState(false);
  const productSearchTimeoutRef = useRef(null);
  const productSearchRequestRef = useRef(0);

  useEffect(() => {
    return () => clearTimeout(productSearchTimeoutRef.current);
  }, []);

  const searchProductsStock = (searchText) => {
    const requestId = ++productSearchRequestRef.current;
    setIsSearchingProducts(true);
    WarehouseService.searchProductsStockInWarehouse(
      getCurrentUserId(),
      warehouseSourceId,
      searchText
    )
      .then((response) => {
        if (requestId !== productSearchRequestRef.current) return;
        const data = response.data || {};
        const productStocks =
          data.productStock ||
          data.productStocks ||
          (data.success && (data.success.productStock || data.success.productStocks)) ||
          (Array.isArray(data.success) ? data.success : []);
        setAllProducts(
          productStocks.map((element) => ({
            value: element.id,
            label:
              element.product.productCode +
              "-" +
              element.product.barcode +
              "-" +
              element.product.name,
            barcode: element.product.barcode,
            customElements: {
              quantity: element.quantity,
            },
          }))
        );
      })
      .catch((e) => {
        console.log("error", e);
      })
      .finally(() => {
        if (requestId === productSearchRequestRef.current) {
          setIsSearchingProducts(false);
        }
      });
  };

  const onProductInputChange = (inputValue, { action }) => {
    if (action !== "input-change") return;
    clearTimeout(productSearchTimeoutRef.current);
    if (inputValue.trim() === "") {
      productSearchRequestRef.current++;
      setIsSearchingProducts(false);
      return;
    }
    productSearchTimeoutRef.current = setTimeout(
      () => searchProductsStock(inputValue.trim()),
      PRODUCT_SEARCH_DELAY_MS
    );
  };

  const onChangeSelectedProduct = (selectedOptionn) => {
    setSelectedOptionProduct();
    setProduct(selectedOptionn.value);
    setCurrentQteProductPurchase(selectedOptionn.customElements.quantity);
  };
  function handleTableChange({ productTableData }) {
    return productTableData;
  }
  const labelStyle = {
    fontSize: "0.8rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    color: "#6c757d",
  };
  const cardStyle = { borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            <div class="row">
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <label style={labelStyle}>Dépôt source</label>
                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOption}
                    onChange={onChangeSelectedWarehouseSource}
                    options={allWarehouseSource}
                    placeholder="Choisir..."
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <label style={labelStyle}>Dépôt destination</label>
                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionTwo}
                    onChange={onChangeSelectedWarehouseDestination}
                    options={allWarehouseDestination}
                    placeholder="Choisir..."
                  />
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <label style={labelStyle}>Transporteur</label>
                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionThree}
                    onChange={onChangeSelectedTransportor}
                    options={allTransportors}
                    placeholder="Choisir..."
                  />
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <label style={labelStyle}>Date limite</label>
                  <TextField
                    style={{ width: "100%" }}
                    className="col-sm-12"
                    variant="outlined"
                    value={date}
                    onChange={handleOnChangeDate}
                    id="datetime-local"
                    type="datetime-local"
                    defaultValue="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    size="small"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label htmlFor="inputDescription" style={labelStyle}>
                    Note
                  </label>
                  <textarea
                    value={transfertNote}
                    placeholder="Saisir..."
                    onChange={onChangeDescriptionHandler}
                    id="inputDescription"
                    className="form-control"
                    rows={3}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      case 1:
        return (
          <div>
            <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label style={labelStyle}>
                    Importer depuis un bon de commande existant
                  </label>
                  <small className="text-muted d-block mb-2">
                    Choisissez la référence d'un bon de commande pour obtenir ses
                    produits.
                  </small>
                  <div className="input-group">
                    <div
                      className="input-group-prepend"
                      style={{ width: "95%" }}
                    >
                      <Select
                        styles={styles}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        defaultValue={availableBDCSelectedOption}
                        onChange={onChangeBDCReferenceHandler}
                        options={allAvailableBDC}
                        placeholder={availableBDCSelectPlaceHolder}
                      />
                    </div>

                    <div className=" input-group-append">
                      <button
                        onClick={onGetBDCByReference}
                        type="button"
                        title="Récupérer les produits du bon de commande"
                        class="btn btn-dark"
                      >
                        <i class="fas fa-arrow-down"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label style={labelStyle}>Produit</label>
                  <Select
                    key="selectProduct"
                    closeMenuOnSelect={true}
                    components={animatedComponentsProduct}
                    defaultValue={"Choisir"}
                    onChange={onChangeSelectedProduct}
                    options={allProducts}
                    onInputChange={onProductInputChange}
                    filterOption={() => true}
                    isLoading={isSearchingProducts}
                    noOptionsMessage={() =>
                      "Tapez un code, un code à barre ou un libellé (recherche après 2 s)"
                    }
                    loadingMessage={() => "Recherche en cours..."}
                    placeholder={"Choisir"}
                  />
                </div>
              </div>

              <div className="col-sm-6">
                <div className="form-group">
                  <label style={labelStyle}>
                    Quantité ({currentQteProductPurchase})
                  </label>
                  <input
                    onChange={handlerChangeQt}
                    type="number"
                    min="0"
                    id="inputClientCompany"
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div className="col-sm-12  text-center">
                <button
                  style={{ marginBottom: 20 }}
                  className="btn btn-dark"
                  onClick={onAddProductToList}
                >
                  <i className="fas fa-plus mr-1"></i>
                  Ajouter à la liste
                </button>
              </div>
            </div>
            <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  {productTableData && (
                    <ToolkitProvider
                      keyField="idProduct"
                      data={productTableData}
                      columns={columns}
                      onTableChange={handleTableChange}
                    >
                      {(props) => (
                        <div className="row">
                          <BootstrapTable
                            {...props.baseProps}
                            headerClasses="thead-light"
                            wrapperClasses="table-responsive w-100"
                            striped
                            hover
                            condensed
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="form-group" class=" col-12 col-sm-12">
              <MaterialTable
                style={{ marginTop: 20 }}
                title=""
                options={{
                  actionsColumnIndex: -1,
                  pageSize: 2,
                  pageSizeOptions: [2, 5, 10, 20],
                  selection: false,
                  search: false,
                  rowStyle: {
                    backgroundColor: "#EEE",
                  },
                  headerStyle: {
                    backgroundColor: "#01579b",
                    color: "#FFF",
                  },
                }}
                columns={[
                  { title: "Nom de produits", field: "productName" },
                  { title: "Quantité", field: "qte" },
                ]}
                data={productTableData}
                actions={[
                  {
                    icon: "delete",
                    iconProps: { color: "secondary" },
                    tooltip: "Supprimer",
                    onClick: (event, rowData) => onDeleteProduct(rowData.id),
                  },
                ]}
                components={{
                  Toolbar: () => null,
                }}
              />
            </div> */}
          </div>
        );
      case 2:
        return (
          <div className="alert alert-warning d-flex align-items-center mb-0" role="alert">
            <i className="fas fa-exclamation-triangle mr-2"></i>
            Avant de cliquer sur terminer, vous devez être sûr de l'information
            entrée.
          </div>
        );
      default:
        return "Unknown step";
    }
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <h4 className="mb-1">
            <i className="fas fa-exchange-alt mr-2"></i>Transfert entre dépôts
          </h4>
          <small className="text-muted">
            Créez une demande de transfert de produits d'un dépôt vers un autre
          </small>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-outline card-dark" style={cardStyle}>
                <div className="card-header">
                  <div className={classes.root}>
                    <Stepper activeStep={activeStep}>
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </div>
                </div>
                {activeStep === steps.length ? (
                  <div>
                    <div className="card-body text-center py-5">
                      <i
                        className="fas fa-check-circle fa-3x mb-3 d-block"
                        style={{ color: "#28a745" }}
                      ></i>
                      <h5>La demande de transfert est faite</h5>
                    </div>
                    <div className="card-footer text-right">
                      <button className="btn btn-dark" onClick={handleReset}>
                        <i className="fas fa-undo mr-1"></i>
                        Nouveau transfert
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="card-body">{getStepContent(activeStep)}</div>
                    <div className="card-footer d-flex justify-content-between">
                      <button
                        disabled={activeStep === 0}
                        className="btn btn-outline-secondary"
                        onClick={handleBack}
                      >
                        <i className="fas fa-arrow-left mr-1"></i>
                        Précédent
                      </button>
                      <button className="btn btn-dark" onClick={handleNext}>
                        {activeStep === steps.length - 1 ? (
                          <>
                            <i className="fas fa-check mr-1"></i>Terminer
                          </>
                        ) : (
                          <>
                            Suivant<i className="fas fa-arrow-right ml-1"></i>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={2000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(WarehouseTransfertAdmin);
